module.exports = __webpack_public_path__ + "static/media/135U11_LivingRoom.a5b42ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U11_LivingRoom.jpg
// module id = 543
// module chunks = 0